type ReferrerState = {
    referrer?: string[]
    [key: string]: unknown
}

export function appendReferrer(
    state: ReferrerState | null | undefined,
    currentUrl: string
) {
    return {
        ...state,
        // Home is the root of the back stack: links from it start a new one.
        referrer:
            currentUrl === '/'
                ? ['/']
                : [...(state?.referrer || ['/']), currentUrl]
    }
}
